<ng-container *ngIf="{ adConfigs: adConfigs$ | async } as subs">
  <div class="ad-skin d-none d-xl-block">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="subs.adConfigs | mapGet: 'skin'"
    ></flo-lazy>
  </div>
  <main class="result-page" *ngIf="view$ | async as ranking">
    <div class="d-none d-lg-block mb-3">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="subs.adConfigs | mapGet: 'leaderboard-large'"
        [detectorHeight]="90"
      ></flo-lazy>
    </div>
    <div class="d-none d-md-block d-lg-none mb-3">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="subs.adConfigs | mapGet: 'leaderboard-small'"
        [detectorHeight]="90"
      ></flo-lazy>
    </div>
    <div class="container right-rail" data-test="ranking-container">
      <div class="row main-row">
        <section class="col-md-12 col-lg-8 border-lg-right wrapper">
          <div class="row">
            <section class="col-12 detail">
              <h1>{{ ranking?.title }}</h1>
              <div class="social-bar row">
                <div class="col-8 ranking-info subhead color-500">
                  {{ ranking.authorLeadInText }} <flo-author-date [firstName]="ranking.authorDate.firstName" [lastName]="ranking.authorDate.lastName" [date]="ranking.authorDate.date"></flo-author-date>
                </div>
              </div>
              <p class="title" data-test="small-subtitle">{{
                ranking?.currentRankingSet?.headline | floTruncate
              }}</p>
              <p
                class="description"
                data-test="description"
                [innerHtml]="
                  ranking?.currentRankingSet?.description | floSanitizeHtml
                "
                floDynamicContent
              ></p>
            </section>
            <div class="d-block d-sm-none mx-auto">
              <flo-lazy
                [componentConstructor]="AdComponent"
                [initialProps]="subs.adConfigs | mapGet: 'content-mobile'"
              >
              </flo-lazy>
            </div>
            <section class="col-12 tabs" data-test="ranking-section">
              <old-flo-tabs [limit]="4">
                <old-flo-tab
                  *ngFor="let tab of ranking?.tabList; trackBy: trackByTab"
                  [tabTitle]="tab?.name"
                  [route]="tab?.uri"
                  [active]="tab?.active"
                >
                </old-flo-tab>
                <div class="flo-sort-container">
                  <form
                    [formGroup]="filterForm"
                    class="dropdown-form"
                    data-test="date-dropdown"
                    *ngIf="ranking.filterList"
                  >
                    <div class="dropdown">
                      <select
                        formControlName="sort"
                        (change)="onNavigate($event.target.value)"
                        class="dropdown-btn"
                      >
                        <option
                          *ngFor="
                            let filter of ranking.filterList;
                            trackBy: trackByFilter
                          "
                          [attr.value]="filter.slug_uri"
                          [attr.selected]="filter.selected"
                        >
                          {{ filter.publish_date | date: 'mediumDate' }}</option
                        >
                      </select>
                      <span
                        floSvg="icon-angle-down"
                        class="apply-text-active svg-icon-xl svg-vertical-align-middle"
                        aria-hidden="true"
                      ></span>
                    </div>
                  </form>
                </div>

                <div
                  *ngIf="!ranking.paywall"
                  class="content"
                  data-test="ranking-content"
                  [innerHtml]="
                    ranking?.currentRankingSet?.content | floSanitizeHtml
                  "
                  floDynamicContent
                >
                </div>
              </old-flo-tabs>
              <flo-paywall
                *ngIf="ranking?.paywall"
                wrapped="true"
                [redirect]="ranking?.redirectParam"
                [loggedIn]="ranking?.loggedIn"
                [promptOverride]="paywallMessage"
                contentType="ranking"
              ></flo-paywall>
            </section>
          </div>
        </section>

        <aside class="col-12 col-lg-4 px-3 px-xl-4 pt-0 pt-sm-2">
          <div class="px-xl-2" data-test="right-rail">
            <div class="d-flex justify-content-center lazy-flex-container py-4">
              <flo-lazy
                [componentConstructor]="AdComponent"
                [initialProps]="subs.adConfigs | mapGet: 'rectangle-small'"
                [detectorHeight]="250"
              ></flo-lazy>
            </div>
          </div>

        </aside>
      </div>
    </div>
      <flo-adhesion-footer>
        <div class="adhesion-ad d-sm-none">
          <flo-lazy
            [componentConstructor]="AdComponent"
            [initialProps]="subs.adConfigs | mapGet: 'adhesion'"
          >
          </flo-lazy>
        </div>
      </flo-adhesion-footer>
  </main>
</ng-container>
